// service request list

import { Dimensions} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize,} from "rn-responsive-styles";
import { COLORS } from "../../constant";


const useStyles = CreateResponsiveStyle(
  {
    container: {
      marginLeft: 40,
      height: "100%",
    },
    listContainer: {
      width: 360,
      height: 440,
      marginRight: 40,
    },
    listWrapper: {
      flexDirection: "row",
      justifyContent: "space-between",
      borderRadius: 10,
      borderColor: COLORS.boderColor,
      borderWidth: 1,
      padding: 10,
      marginBottom: 15,
    },
    listRightCnt: {},
    listHeader: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    refreshWrapper: {
      flexDirection: "row",
      alignItems: "center",
      borderRadius: 15,
      borderWidth: 1,
      borderColor: COLORS.red300,
      paddingHorizontal: 30,
      paddingVertical: 6,
      marginRight: 20,
    },
    refresText: {
      fontFamily: "inter",
      fontSize: 11,
      color: COLORS.black200,
    },
    srStatusStyle: {
      fontFamily: "Inter",
      fontSize: 17,
      color: COLORS.black450,
      fontWeight: "bold",
      paddingVertical: 8,
    },

    SvcRq_Body: {
      flexGrow: 1,
      flexDirection: "row",
    },
    SvcRq_row3_row1_col1_Heading: {
      fontFamily: "Inter",
      fontSize: 22,
      fontWeight: "bold",
      color: COLORS.black200,
      textIndent: 5,
    },
    SvcRq_row3_row1_col2: {
      alignItems: "center",
      flexDirection: "row",
    },
    searchBar: {
      width: "100%",
      height: 35,
      marginLeft: 10,
      backgroundColor: "#fff",
      paddingHorizontal: 8,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      borderColor: COLORS.warmGrey2,
      borderWidth: 1,
      borderRadius: 8,
      marginVertical: 15,
      marginLeft: 0,
    },
    SvcRq_row3_row1_col2_searchField: {
      height: "100%",
      width: 130,
      fontFamily: "Inter",
      fontSize: 8,
      letterSpacing: "0.61px",
      color: "#66625f",
      paddingLeft: 5,
    },
    SvcRq_row3_row1_col2_searchIcon: {
      width: 14,
      height: 14,
    },
    SvcRq_row3_row1_col2_searchIcon_image: {
      height: "100%",
      width: "100%",
    },
  },

  {
    [maxSize(DEVICE_SIZES.LG)]: {},

    [maxSize(DEVICE_SIZES.MD)]: {
      SvcRq_Body: {
        paddingLeft: 40,
      },
      listContainer: {
        height: 360,
      },
      listContainer: {
        marginTop: 20,
      },
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      container: {
        marginLeft: 0,
        width: "100%",
      },
      SvcRq_Body: {
        paddingLeft: 0,
      },
      listContainer: {
        width: 360,
        marginRight: 0,
      },
      SvcRq_Body: {
        paddingLeft: 0,
      },
      searchBar: {
        marginLeft: 0,
      },
    },
    [maxSize(DEVICE_SIZES.XS)]: {
      container: {
        marginHorizontal: 5,
        height: Dimensions.get("window").height,
      },
      refreshWrapper: {
        paddingHorizontal: 20,
      },
      SvcRq_Body: {
        paddingLeft: 0,
      },
      SvcRq_row3_row1_col2_searchField: {},
      listContainer: {
        width: 270,
        marginRight: 0,
        height: 320,
        marginTop: 0,
      },
      listWrapper: {
        width: "90%",
      },
      searchBar: {
        width: "90%",
      },
      srStatusStyle: {
        fontSize: 11,
      },
      SvcRq_row3_row1_col1_Heading: {
        textIndent: 0,
        fontSize: 15,
      },
      SvcRq_row3_row1_col2: {
        alignItems: "center",
        flexDirection: "row",
      },

      SvcRq_row3_row1_col2_searchIcon: {
        width: 14,
        height: 14,
      },
      SvcRq_row3_row1_col2_searchIcon_image: {
        height: "100%",
        width: "100%",
      },
    },
  }
);

export default useStyles;